import React from 'react';
import Slider from 'react-slick';
import { images } from '../../../assets/images'


function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-right"></i>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-left"></i>
        </div>
    );
}

function HomeSlider() {
    var settings = {
        autoplay: true,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    };
    return (
        <div className="hero_slider">
            <div className="hero_slider_area">
                <Slider {...settings}>
                    <div>
                        <img src={images.Banner_1} alt="..." className='img-fluid' />
                    </div>
                    <div>
                        <img src={images.Banner_2} alt="..." className='img-fluid' />
                    </div>
                </Slider>
            </div>
        </div>
    );
}

export { HomeSlider };
